import { render, staticRenderFns } from "./AddPricelistItem.vue?vue&type=template&id=289af8a6&scoped=true"
import script from "./AddPricelistItem.vue?vue&type=script&lang=js"
export * from "./AddPricelistItem.vue?vue&type=script&lang=js"
import style0 from "./AddPricelistItem.vue?vue&type=style&index=0&id=289af8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289af8a6",
  null
  
)

export default component.exports